module.exports = "data:text/markdown;base64,IyMjIFNjaGVkdWxlZAoKVG90YWwgbnVtYmVyIG9mIHByb3NwZWN0cyBzY2hlZHVsZWQgdG8gYmUgY2FsbGVkIGJhY2suCg=="